import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import WhatsAppButton from "@/components/ui/WhatsAppButton";

const PainSection: React.FC = () => {
  return (
    <section className="py-8 md:py-16 px-4 md:px-6 bg-background">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center mb-6 md:mb-10">
          <p className="text-xs tracking-widest font-medium uppercase text-primary mb-2">
            TRABALHA COM SAÚDE?
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground">
            A alta carga tributária dificulta seu crescimento
          </h2>
        </div>

        <Card className="shadow-sm">
          <CardContent className="p-4 md:p-6 space-y-4 text-muted-foreground leading-relaxed">
            <p>
              Muitos profissionais e empresas na área da saúde enfrentam desafios financeiros que dificultam o crescimento e o sucesso de seus negócios.
            </p>
            <p>
              Um desses desafios é a <strong className="text-foreground">alta carga tributária</strong>, que pode consumir uma parte significativa dos lucros, deixando pouco espaço para investimentos em infraestrutura, tecnologia e capacitação da equipe.
            </p>
            <p>
              É frustrante perceber que uma parte considerável dos lucros que você trabalhou arduamente para obter está sendo drenada por impostos, impedindo que você alcance seus objetivos de crescimento e prosperidade.
            </p>

            <div className="pt-4">
              <WhatsAppButton 
                text="QUERO UM CONTATO"
                source="pain_section"
                size="lg"
                className="w-full md:w-auto min-h-[48px]"
                showIcon={false}
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default PainSection;
